import React from 'react';
import styled from 'styled-components';
import HBText from '../../HBText/HBText';
import HBLinkButton from '../../HBLinkButton/HBLinkButton';
import { vars } from '../../../theme';

interface Props {
    onSave: () => void;
    onClose(): void;
    title?: string;
    testId: string;
}

const HBColorPickerDrawerHeader = ({
    onSave,
    onClose,
    title = 'Select brand color',
    testId
}: Props) => (
    <Header role="banner" aria-labelledby={`${testId}-title`}>
        <CancelButton
            size="md"
            testId={`${testId}-cancel`}
            onClick={onClose}
            aria-label="Cancel"
        >
            Cancel
        </CancelButton>
        <Title type="emphasis18" tag="h3">
            {title}
        </Title>
        <HBLinkButton
            size="md"
            testId={`${testId}-done`}
            linkButtonTheme="accent"
            onClick={onSave}
            aria-label="Done"
        >
            Done
        </HBLinkButton>
    </Header>
);

export default HBColorPickerDrawerHeader;

// -------------------------------- Styles -------------------------------- //
const Header = styled.header`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 72px;
    padding: 0 16px;
    background-color: ${vars.colors.surface.container};
    box-shadow: ${vars.shadow['50']};
`;

const Title = styled(HBText)`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;
`;

const CancelButton = styled(HBLinkButton)`
    color: ${vars.colors.text.secondary};
    &:hover {
        color: ${vars.colors.text.primary};
    }
`;
